import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  isTriggerExpandHideSidebar: Subject<boolean> = new Subject<boolean>();
  constructor() { }

}
